module.exports = "<div range-select-bar range-type=\"DAY\" handle-moment-change=\"handleMomentChange(startMoment, endMoment)\"></div>";